import {
  AfterViewInit,
  Component, ElementRef, Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import React from 'react';
import {createRoot, Root} from 'react-dom/client';
import {DocumentRenderer, DocumentRendererProps} from '@keystone-6/document-renderer';
import {AssetTypeType} from '../../../../gql/graphql';

window.React = React;

@Component({
  selector: 'app-document-renderer',
  template: `<span #containerEl class="document"></span>`,
  styleUrls: ['./document-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentRendererComponent implements OnChanges, OnDestroy, AfterViewInit {

  root: Root | null = null;
  @ViewChild('containerEl', {static: false}) containerRef!: ElementRef<HTMLSpanElement>;
  @Input() public document: any;

  renderers: DocumentRendererProps['renderers'] = {
    inline: {
      relationship({ relationship, data }) {
        if (relationship !== 'mention')
        {
          return null;
        }

        const asset = data?.data

        if (!asset){
          return <span></span>
        }

        const fileUrl = asset['file']?.url as string | undefined;

        if (asset['type'] === AssetTypeType.IMAGE) {
          return fileUrl ? <img src={fileUrl} alt=""/> : <span></span>;
        }

        if (asset['type'] === AssetTypeType.DOCUMENT) {
          if (!fileUrl) {
            return <span>{asset['name']}</span>;
          }
          return <a href={fileUrl}><i className="fa-light fa-download"/>{asset['name']}</a>;
        }
  
        return null;
      },
    },
  };

  constructor() { }

  ngAfterViewInit(): void {
    this.root = createRoot(this.containerRef.nativeElement);
    this.render();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngOnDestroy(): void {
    this.root?.unmount();
  }

  private render() {
    this.root?.render(<DocumentRenderer document={this.document} renderers={this.renderers}/>)
  }
}
